import { get } from 'lodash';
import { ErrorValidation, Field, FormStrucItem, TreeNodeType } from '../types/types';
import { GetFieldErrors } from './ApplicationValidator';
// import Schema from '../paths/antrag_FULL_Paths.json';
// const P = Schema.attributes;

const COMPONENT_TABLE = 'componentTable';
// const P = Schema.attributes;

export function findErrorByKey(treeItems: TreeNodeType[] | undefined, key: string, type: string): boolean | undefined {
	// console.log("DEBUG TreeItem:: FindError key", key);
	// console.log("DEBUG TreeItem:: FindError", treeItems);
	const item = treeItems?.find((treeItem: TreeNodeType) => {
		if (treeItem.children) {
			return findErrorByKey(treeItem.children, key, type);
		}
		if (treeItem.formStruc) {
			return treeItem.formStruc?.some((fieldGroup: FormStrucItem) => {
				return fieldGroup.fields?.some((field: Field) => {
					if (type === COMPONENT_TABLE) return field.path.includes(key);
					return field.path === key;
				});
			});
		}
		return null;
	});
	// console.log("DEBUG ITEMError", item);

	return item ? item.showError : undefined;
}

export function checkErrorInCurrentNode(tree: TreeNodeType[], error: any, currentNode: string): boolean {
	let errorItem = tree.find((item) => {
		if (item.formStruc && item.id === currentNode) {
			return item.formStruc.some((fieldGroup: any) => {
				return fieldGroup.fields?.some((field: any) => {
					// console.log('NEWTEST3 field ', field);
					//compare data-path with errorList
					return error?.some((validationError: ErrorValidation) => validationError.path.includes(field.path));
				});
			});
		} else if (item.children) return checkErrorInCurrentNode(item.children, error, currentNode);
		else return false;
	});

	return errorItem ? true : false;
}

export function validateAll(application: any, structure: TreeNodeType[], setErrors: any, readOnly: boolean, onlyVisitedNodes?: boolean,
): TreeNodeType[] {
	const errorList = GetFieldErrors(structure, application, readOnly);
	setErrors(errorList);
	const errorPaths = new Set(errorList.map((error: ErrorValidation) => error.path));

	const newStruc = validateStructure(structure, errorPaths, onlyVisitedNodes? true : false);

	return newStruc;
}

function validateStructure(treeStructure: TreeNodeType[], errorPaths: Set<string>, onlyVisitedNodes: boolean): TreeNodeType[] {
	treeStructure.forEach((item: TreeNodeType) => {
		if(onlyVisitedNodes && !(item.hasBeenVisited || item.showError)) return item
		if(!onlyVisitedNodes) item.hasBeenVisited = true;
		
		let itemHasError = false;
		let childHasError = false;

		if (item.children) {
			const child = validateStructure(item.children, errorPaths, onlyVisitedNodes);
			childHasError = child.some((childItem) => {
				return childItem.showError;
			});
		}
		if (item.formStruc) {
			item.formStruc.forEach((formStrucItem) => {
				formStrucItem.fields?.forEach((field: Field) => {
					if (errorPaths?.has(field.path)) {
						itemHasError = true;
					}
				});
			});
		}
		item.showError = childHasError? true: itemHasError;
		return item as TreeNodeType;
	});
	return treeStructure;
}

export function setShowError(treeStructure: TreeNodeType[], curNode: string[], hasError: boolean) {
	console.log('set show error curNode', curNode);
	if (curNode.length === 1) {
		const currentNode = treeStructure?.find((ele: TreeNodeType) => ele.id === curNode[0]);
		if (currentNode && currentNode.showError !== hasError) currentNode.showError = hasError;
	}
	if (curNode.length > 1) {
		const parentNode = treeStructure?.find((ele: TreeNodeType) => ele.id === curNode[0]);
		const childNode = parentNode?.children?.find((ele: TreeNodeType) => ele.id === curNode[1]);
		setShowErrorInNodes(parentNode, childNode, hasError);
	}
}

function setShowErrorInNodes(parentNode: TreeNodeType | undefined, childNode: TreeNodeType | undefined, hasError: boolean) {
	if (parentNode && hasError === true) {
		parentNode.showError = true;
		if (childNode && childNode.showError !== hasError) childNode.showError = hasError;
	} else {
		if (childNode && childNode.showError !== hasError) {
			childNode.showError = hasError;
		}
		//check if all child are false and set parent to false
		const hasNoError = parentNode?.children?.every((child) => !child.showError);
		if (parentNode && hasNoError) {
			parentNode.showError = false;
		}
	}
}

export function setHasBeenVisited(treeStructure: TreeNodeType[], curNode: string[]) {
	if (curNode.length === 1) {
		const currentNode = treeStructure?.find((ele: TreeNodeType) => ele.id === curNode[0]);
		if (currentNode) currentNode.hasBeenVisited = true;
	}
	if (curNode.length > 1) {
		const parentNode = treeStructure?.find((ele: TreeNodeType) => ele.id === curNode[0]);
		if (parentNode) parentNode.hasBeenVisited = true;
		const childNode = parentNode?.children?.find((ele: TreeNodeType) => ele.id === curNode[1]);
		if (childNode) childNode.hasBeenVisited = true;
	}
}

function hasErrorInField(errors: any[], path: string) {
	let errorInField = Boolean(
		(Array.isArray(errors) ? errors : []).find((e) => {
			return get(e, 'path', '') === path;
		}),
	);

	return errorInField
}

export function getHasError(errors: any[], tree: TreeNodeType[], obj: any ) {
	const {path, type} = obj
	const errorInField = hasErrorInField(errors, path)
	const showError = findErrorByKey(tree, path, type)

	return errorInField && showError

}

export function getErrorMessage(errors: any[], path:string ) {
	const errorMessage = get(errors.find((e) => e.path === path), "message", "")

	return errorMessage
}
